import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: false,
})
export class AccessDeniedComponent implements OnInit {
  public accessDeniedBreadcrumbs = [{ text: 'Органичение доступа', url: null }];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.accessDeniedBreadcrumbs);
  }
}
